export default {
  hotel: {}
}
